import { useEffect } from 'react'
import { facebookAuth } from '../../features/authSlice.js'
import { useDispatch } from 'react-redux'
import FacebookIcon from '@mui/icons-material/Facebook'
import { Button, Typography } from '@mui/material'
import ButtonCustom from '../atoms/button/ButtonCustom.jsx'

// A button component that enables Facebook login using Facebook's JS SDK
export const FacebookLoginButton = () => {
	const dispatch = useDispatch()
	const appId = process.env.REACT_APP_FACEBOOK_APP_ID // Facebook App ID from environment variables

	// Triggered when the user clicks the button to log in with Facebook
	const handleFacebookLogin = () => {
		// Call Facebook's login dialog
		window.FB.login(
			(response) => {
				if (response.authResponse) {
					// Extract access token and user ID if login is successful
					const { accessToken, userID } = response.authResponse

					// Dispatch the Redux action to authenticate the user on the backend
					dispatch(
						facebookAuth({
							accessToken,
							userID,
						})
					)
				} else {
					// User either cancelled or didn't complete login
					console.log(
						'User cancelled login or did not fully authorize.'
					)
				}
			},
			{ scope: 'public_profile,email' } // Request email and profile info
		)
	}

	// Loads Facebook's JavaScript SDK into the page once on component mount
	useEffect(() => {
		const loadFbSdk = () => {
			// Avoid reloading if SDK is already added
			if (document.getElementById('facebook-jssdk')) return
			const script = document.createElement('script')
			script.id = 'facebook-jssdk'
			script.src = 'https://connect.facebook.net/en_US/sdk.js'
			script.async = true

			// Initialize the SDK once it has loaded
			script.onload = () => {
				window.FB.init({
					appId: appId, // Your Facebook App ID
					cookie: true, // Enable cookies to allow backend session management
					xfbml: true, // Parse social plugins (not necessary here but can be left on)
					version: 'v18.0', // SDK version to use
				})
			}
			document.body.appendChild(script)
		}
		loadFbSdk() // Run SDK loading function
	}, [])

	return (
		<ButtonCustom
			onClick={handleFacebookLogin}
			variant="outlined"
			// sx={{ bgcolor: '#6991A3', color: '#FFF' }}
			// endIcon={<FacebookIcon />}
		>
			<img src="/images/fb-icon.svg" />
			<Typography variant="body">Continue with Facebook</Typography>
		</ButtonCustom>
	)
}
